export default function truncateString(str: string, num: number) {
  if (!str) return null
  if (str?.length <= num) return str
  return str?.slice(0, num)?.trim() + '...'
}
